import React from 'react';
import logo from '../../assets/glacieswhitefason1.png';

const StandaloneHeaderComponent = () => {
    return (
        <div style={{
            width: '100%',
            height: '60px',
            backgroundColor: '#2E2648',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between'
        }}>
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%'
            }}>
                <img src={logo} alt="Logo" style={{height: '50px'}}/>
            </div>
        </div>
    );
};

export default StandaloneHeaderComponent;